import React from 'react';

/**
 * Page title block. The availability selector, notification bell, Welcome menu
 * and phone launcher now live once in the global header (components/layout/
 * HeaderCluster.jsx, rendered by Layout) so they appear on every page and never
 * double up when pages nest.
 * @param {{title?: string, subtitle?: string, right?: React.ReactNode}} props
 */
export default function TopBar({ title, subtitle, right }) {
  if (!title && !subtitle && !right) return null;
  return (
    <div className="flex items-start justify-between gap-4 mb-6">
      <div className="min-w-0">
        {subtitle && (
          <div className="text-civix-purpleSoft/80 uppercase tracking-[0.3em] text-xs">{subtitle}</div>
        )}
        {title && <h1 className="font-display text-3xl font-bold mt-1 truncate">{title}</h1>}
      </div>
      {right && <div className="flex items-center gap-2 shrink-0">{right}</div>}
    </div>
  );
}
